// ─────────────────────────────────────────────────────────────────────────
// Custom-checkout feature flag (Payment Element migration).
//
// The migration from hosted Stripe Checkout to our own on-page Payment Element
// checkout ships behind this flag so every surface can fall back to the hosted
// redirect instantly. Both the client (to decide navigate-to-/checkout vs
// redirect-to-Stripe) and the server (to decide clientSecret vs hosted session)
// read the SAME NEXT_PUBLIC_ flag, so they can never disagree within a build.
//
// Enable per environment by setting NEXT_PUBLIC_CUSTOM_CHECKOUT=1. Rollout is
// phased (trial → subscribe → upgrade/topup); until a surface is wired to the
// custom page it keeps using the hosted route regardless of this flag.
// ─────────────────────────────────────────────────────────────────────────

export function isCustomCheckoutEnabled(): boolean {
  return process.env.NEXT_PUBLIC_CUSTOM_CHECKOUT === "1";
}

/**
 * Build the /checkout URL for a purchase. Drops empty/undefined params so each
 * initiation site can pass its optional fields (projectId, cadence, …) without
 * ceremony. The /checkout page reads these to mint the right intent.
 */
export function customCheckoutHref(
  params: Record<string, string | number | null | undefined>,
): string {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== null && v !== undefined && v !== "") q.set(k, String(v));
  }
  return `/checkout?${q.toString()}`;
}
